import { LinearProgress, Typography, Box, withStyles } from "@material-ui/core"
import { COLOR_WHITE } from "../../../constants"

const CustomLinearProgress = withStyles({
  root: {
    minHeight: 24,
    borderRadius: 5,
    width: "100%",
  },
  bar: {
    borderRadius: 5,
  },
})(LinearProgress)

const ProgressBar = ({ label, value }: { label: string; value: number }) => {
  const progressValue = value > 100 ? 100 : value < 0 ? 0 : value

  return (
    <Box>
      <Box sx={{ paddingRight: "24px" }}>
        <Typography variant="body2">{label}</Typography>
      </Box>
      <Box width="100%" position="relative">
        <CustomLinearProgress variant="determinate" value={progressValue} />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          style={{ transform: "translate(-50%, -50%)", color: COLOR_WHITE }}
        >
          <Typography variant="body1">{`${Math.round(value)}%`}</Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default ProgressBar
